"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMobileModal = void 0;
const react_1 = __importDefault(require("react"));
const fdr_travel_dates_styles_1 = require("./fdr-travel-dates.styles");
function FdrMobileModal({ children, label, title, show, className, closeModal, }) {
    return (react_1.default.createElement(fdr_travel_dates_styles_1.FdrTravelDatesMobileModalWrapper, { fullScreen: true, name: "travelDates", label: label, title: title, show: show, onClose: closeModal, className: className }, children));
}
exports.FdrMobileModal = FdrMobileModal;
//# sourceMappingURL=fdr-mobile-modal.js.map